import { TFunction } from 'next-i18next';

import { AlgoliaFacets } from '@utils/algolia/knownFacetNames';
import { isEffectivePriceAttribute } from '@utils/algolia/priceContext';

export const getFacetTitle = (attribute: string, t: TFunction): string => {
  if (attribute.startsWith('categories')) return t('search.facet.category');
  if (attribute === AlgoliaFacets.Price || isEffectivePriceAttribute(attribute))
    return t('search.facet.price');

  const titles: Record<string, string> = {
    [AlgoliaFacets.Gender]: t('search.facet.gender'),
    [AlgoliaFacets.Brand]: t('search.facet.brand'),
    [AlgoliaFacets.Colour]: t('search.facet.colour'),
    [AlgoliaFacets.ColourVariants]: t('search.facet.colour'),
    [AlgoliaFacets.Rating]: t('search.facet.rating'),
    [AlgoliaFacets.ReviewScoreFlattened]: t('search.facet.rating'),
    size: t('search.facet.size_bucketing'),
    [AlgoliaFacets.ClothingSizeKids]: t('search.facet.size.clothing.kids'),
    [AlgoliaFacets.ClothingSizeMens]: t('search.facet.size.clothing.mens'),
    [AlgoliaFacets.ClothingSizeWomens]: t('search.facet.size.clothing.womens'),
    [AlgoliaFacets.SizeClothingKids]: t('search.facet.size.clothing.kids'),
    [AlgoliaFacets.SizeClothingMens]: t('search.facet.size.clothing.mens'),
    [AlgoliaFacets.SizeClothingWomens]: t('search.facet.size.clothing.womens'),
    [AlgoliaFacets.SizeShoeMens]: t('search.facet.size.shoe.mens'),
    [AlgoliaFacets.SizeShoeWomens]: t('search.facet.size.shoe.womens'),
    [AlgoliaFacets.Promotions]: t('search.facet.promotions'),
    shopCanadian: t('search.facet.shopCanadian'),
  };

  return titles[attribute] ?? attribute.replace('facets.', '');
};

export const getFacetPluralLabel = (
  attribute: string,
  t: TFunction
): string => {
  const plurals: Record<string, string> = {
    [AlgoliaFacets.Brand]: t('search.facet.brand.plural'),
    [AlgoliaFacets.Gender]: t('search.facet.gender.plural'),
  };

  return plurals[attribute] ?? getFacetTitle(attribute, t).toLowerCase();
};
